export const VIEW_SPARQL_EDITOR = 'graphdb-workbench-sparql-editor';
